// main.js
import Vue from 'vue';
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';

Vue.component('vue-typeahead-bootstrap', VueTypeaheadBootstrap);